var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cart-section section-b-space",staticStyle:{"position":"relative"}},[_c('LegendComponent',{attrs:{"legend":_vm.legendCustomer}}),_c('chart',{attrs:{"data":_vm.customer}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }